import styled from 'styled-components';

const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    gap: var(--spacing-3);
  }
`;

const AccordionItem = styled.div<{ $isOpen: boolean }>`
  border-bottom: ${({ $isOpen }) =>
    $isOpen ? 'none' : '1px solid var(--color-gray-100)'};
  // overflow: hidden;
`;

const AccordionHeader = styled.div<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-4) 0;
  cursor: pointer;
  transition: var(--transition-fast);

  @media (max-width: 768px) {
    padding: var(--spacing-3) 0;
  }
`;

const AccordionTitle = styled.h3`
  font-size: var(--font-size-32);
  font-weight: var(--font-weight-bold);
  color: var(--color-gray-900);
  margin: 0;

  @media (max-width: 768px) {
    font-size: var(--font-size-24);
  }

  @media (max-width: 480px) {
    font-size: var(--font-size-20);
  }
`;

const AccordionIcon = styled.div<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition-fast);
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(0deg)' : 'rotate(0deg)')};
`;

const AccordionContent = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  background-color: var(--color-white);
  width: 100%;
  max-height: none;
`;

const AccordionNote = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  color: var(--color-primary-600);
  padding: 0.75rem 1.25rem;
  border: 1px solid var(--color-primary-100);
  border-radius: 0.5rem;
  background-color: var(--color-bg-2);

  h1 > span {
    font-weight: var(--font-weight-bold);
  }

  @media (max-width: 768px) {
    padding: var(--spacing-2) var(--spacing-3);
    gap: var(--spacing-2);
    font-size: var(--font-size-14);
  }
`;
export {
  AccordionContainer,
  AccordionItem,
  AccordionHeader,
  AccordionTitle,
  AccordionIcon,
  AccordionContent,
  AccordionNote,
};
